import { sendDataToParent } from '../../../../base/functions/sendDataToParent';

export const markerOnCreatedAction = (e) => {
    // console.log('marker function event', e);
    const markerCoords = e.layer._latlng;
    sendDataToParent({
        type: 'marker-created',
        markerCoords,
    });
};
